import useApi from '../useApi';
import { useShowSnackbar } from '../useShowSnackbar';

export const useUpdateUser = () => {
  const showSnack = useShowSnackbar();

  const {
    data: response,
    loading,
    error,
    postData,
  } = useApi('/BlazorApi/updateda', 'POST', null, 500000);

  const createUpdateUser = async (body) => {
    const res = await postData({ ...body, RegistrationSource: 1 });
    return res;
  };

  return { response, loading, error, createUpdateUser };
};
